import React,{ useState, useRef, useEffect } from 'react'
import { Formik, Field } from "formik";
import Form, { InputSection,TableSection } from "../components/Form";
import Input from "../../../ui/Input";
import { DropDown } from "../../../ui/DropDown";
import { DropDownGroups } from "../../../ui/DropDownGroups";
import { parseDropdown,parseGroupform } from "../../../utils/parseDropdown";
import { GetHook, postEndpoint, putEndpoint } from "../../../api/api";
import { get } from "../../../utils/get";
import { DeleteIcon } from "../../../assets/svg/DeleteIcon";
import { TitleText } from "../../../ui/Text";
import { toast } from "react-toastify";
import {
  GROUPS_URL,
  USER_URL,
} from "../../../api/urls";
import ModalTable from "../../../ui/ModalTable";
interface IPrps {
  setHandleSubmit?: any;
  closeModal: any;
  editData?: any;
  groups?: any;
  setGroups?: any;
}

const AddGroupForm = ({
  setHandleSubmit,
  closeModal,
  editData,
  groups,
  setGroups,
}: IPrps) => {
  const formRef: any = useRef<any>(null);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const { data: users } = GetHook(USER_URL);
  const options = parseGroupform(users);
  const ownerOptions = parseDropdown(users);
   const [owner, setOwner] = useState();
  const [selectedValue, setSelectedValue] = useState<any>([...options]);
    const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

   const { id } = editData;
   const isAddMode = !id;
   useEffect(() => {
    if (!isAddMode) {
      const newEditData = {
        name: get(editData, "name"),
        owner_id: {
          value: get(editData, "owner.id"),
          label: get(editData, "owner.names"),
        },
        users:get(editData, "users", []).map((user) => {
          return {
            value: get(user, "id", ""),
            label: get(user, "names", ""),
            email: get(user, "email", ""),
          };
        }),
      };
      setSelectedValue(get(editData, "users", []).map((user) => {
          return {
            value: get(user, "id", ""),
            label: get(user, "names", ""),
            email: get(user, "email", ""),
          };
        }))    
      const fields = [
      "name",
      "owner_id",
      "users"
      ];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field] || "", false)
      );
    }
  }, [editData, isAddMode]);
  const handleChange = selectedOptions => {
    setSelectedValue([...selectedOptions]);
    
}
  const addGroup = (values) => {
    const people = selectedValue.map((user) => get(user, "value"));;
    const payload = {
      name: get(values, "name"),
      users: people,
      owner_id: get(values, "owner_id.value"),  
    };
    createReq(GROUPS_URL, payload);
  };

  const editGroup = (values) => {
     const people = selectedValue.map((user) => get(user, "value"));;
      const payload = {
      name: get(values, "name"),
      users: people,
      owner_id: get(values, "owner_id.value"),  
      };
      updateReq(`${GROUPS_URL}/${id}`, payload);
  };
  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message.name"));
    }
    if (!pending && complete && !error) {
      closeModal();
      toast.success("Group added successfully");
    }

    return () => {};
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) {
      console.log(data);

      toast.error(get(data, "message"));
    }
    if (!pending && complete && data && !error) {
      toast.success("Group updated successfully");
      closeModal();
    }
  }, [closeModal, updateRes]);


  const columns = [
    {
      Header: "Name",
      accessor: "label",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      id: "1",
      Header: "",
      accessor: (str) => 'delete',
      Cell: ({ row }: any) => (
        <div style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "1em",
        }}
        onClick={() => {
          const dataCopy = [...selectedValue];
          dataCopy.splice(row.index, 1);
          setSelectedValue(dataCopy);
        }}>
           <span><DeleteIcon/> <span style={{ fontSize: 12, fontWeight: "bold", marginTop: 10 }}>
            Delete
          </span></span>
         
        </div>
      ),
    },
  ];

  const initialValues = {
    name: "",
    owner_id: "",
    users:[],
  };


  return (
       <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={
          isAddMode
          ? (values) => addGroup(values)
          : (values) => editGroup(values)
        
      }
      >
       {({ values, setFieldValue }) => (
        <Form>
          <InputSection>
            <Field
              type="text"
              name="name"
              placeholder="enter Group name"
              label="Group name"
              component={Input}
            />
          </InputSection>
              <Field
              label="Group Members"
              width="18em"
              name="users"
              dropdownLabel="Select members"
              isMulti
              onChange={handleChange}
              value={selectedValue}
              closeMenuOnSelect={false}
              options={options}
              component={DropDownGroups}
              backgroundColor="#F5F6FB"
             />
          <Field
            name="owner_id"
            dropdownLabel="Group Owner"
            component={DropDown}
            options={ownerOptions}
            width="18em"
            backgroundColor="#F5F6FB"
          />
          <TableSection>
          <ModalTable
           data={selectedValue}
           columns={columns}
          />
          </TableSection>
        </Form>
      )}
    

    </Formik>
  )
}

export default AddGroupForm
